/**
 * 69.74 step 1 (DECISIONS 302, the owner: "I couldn't call helicopters (they never showed up)"; GameConfig.helicopters): a
 * helicopter's lift — a person's Go ▸ Fly there on a squad. It is 69.59's pickup with a drop point (`pickup.to`): out empty from
 * its spot by the base to the squad, the squad boarding at its door, then:
 * - **at its lift** it flies on to the drop point instead of home, the squad its riders (69.17's rejoin from where it is), and
 *   they get out of its doors there as a troop call's do;
 * - **once they are out** it flies back to its spot (`lift.home`) and is gone.
 * A lift lifting empty goes home as any pickup does. One broken off on its way (its pilot's answer under fire) flies home with
 * them aboard, and they get out where it ends (core/dropship.ts pickupHome). Pure; nothing runs with no lift in the air.
 */
import type { DropshipFlight, GameState } from '../types';
import { vecNormalize } from '../math';
import { rejoinFlight } from './dropship';
import { flightNow } from './shipNow';

/** The lifts' turns this tick: a pickup with a drop point on to it at its lift, its squad aboard; a lift whose riders are out home to its spot. The same state when none turns. */
export function stepHeliLifts(state: GameState, tick: number): GameState {
  const a = state.dropships;
  const due = (f: DropshipFlight) => tick >= f.liftTick && f.evade?.kind !== 'break' && ((!!f.pickup?.to && !f.rejoin) || !!f.lift);
  if (!a?.flights.some(due)) return state;
  let changed = false;
  const flights = a.flights.map(f => {
    if (!due(f)) return f;
    const now = flightNow(state, f, tick);
    if (!now?.flight) return f;
    const from = { pos: now.flight.pose.pos, vel: now.vel };
    if (f.lift) {   // (its riders out: back to its spot)
      const { lift, ...rest } = f;
      changed = true;
      return rejoinFlight(state, rest, tick, from, lift.home, true);
    }
    const { pickup, ...rest } = f;
    if (!pickup!.units.length) {   // (nobody boarded: home as a pickup)
      changed = true;
      const { to: _to, ...plain } = pickup!;
      return { ...f, pickup: plain };
    }
    changed = true;
    return { ...rejoinFlight(state, { ...rest, riders: [...pickup!.units], out: 0 }, tick, from, pickup!.to!, false), lift: { home: vecNormalize(f.origin) } };
  });
  return changed ? { ...state, dropships: { ...a, flights } } : state;
}
